import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function WhyChoose() {
  const [t] = useTranslation("global");

  return (
    <section className="container">
      <div className="row justify-content-center align-items-center p-3">
        <div className="col-md-6 mb-3">
          <h1 className="main-color m-0 ">{t("whyChoose.titleOne")}</h1>
          <h1 className="second-color m-1 ">{t("whyChoose.titleTwo")}</h1>
          <p className="paragraph-color ">{t("whyChoose.description")}</p>
          <div className="d-flex justify-content-center justify-content-md-start">
            <Link className="btn bg-btn-choose text-white" to={"/about-us"}>
              {t("whyChoose.button")}
            </Link>
          </div>
        </div>
        <div className="col-md-6 mb-3">
          <img
            src="assets/imgs/Group 1410103734.svg"
            width="100%"
            alt={t("whyChoose.titleOne")}
          />
        </div>
      </div>
    </section>
  );
}
